import React from 'react';
import EditLayersSidebar, {EditLayersSidebarProps} from './EditLayersSidebar';
import PerformanceSidebar, {PerformanceSidebarProps} from './PerformanceSidebar';
import LayersSidebar, {LayersSidebarProps} from './LayersSidebar';
import Slide, {SlideProps} from '@material-ui/core/Slide';
import PrintSidebar, {PrintSidebarProps} from './PrintSidebar';
import LayerDetailsSidebar, {LayerDetailsSidebarProps} from './LayerDetailsSidebar';
import DataSidebar, {DataSidebarProps} from './DataSidebar';
import OverlaysSidebar, {OverlaysSidebarProps} from './OverlaysSidebar';
import fetchUser from '../../../utils/gaia/fetchUser';
import useSyncPromise from '../../../utils/react/useSyncPromise';

interface SidebarManagerProps extends
    EditLayersSidebarProps,
    PerformanceSidebarProps,
    LayersSidebarProps,
    Omit<LayerDetailsSidebarProps, 'sidebar'>,
    Omit<PrintSidebarProps, 'sidebar'>,
    DataSidebarProps,
    OverlaysSidebarProps
{
    sidebar: MapSidebar;
    onExited: SlideProps['onExited'];
    onEntered: SlideProps['onEntered'];
}

export default function SidebarManager({
    sidebar,
    onExited,
    onEntered,
    ...props
}: SidebarManagerProps) {

    const [user] = useSyncPromise(fetchUser());

    let output = <div />;

    if (sidebar.type === 'layers') {
        output = <LayersSidebar {...props} />;

    } else if (sidebar.type === 'editLayers') {
        output = <EditLayersSidebar {...props} />;

    } else if (sidebar.type === 'print' && user && user.hasSubscription) {
        output = <PrintSidebar sidebar={sidebar} {...props} />;

    } else if (sidebar.type === 'layerDetails') {
        output = <LayerDetailsSidebar sidebar={sidebar} {...props} />;

    } else if (sidebar.type === 'data') {
        output = <DataSidebar {...props} />;

    } else if (sidebar.type === 'overlays') {
        output = <OverlaysSidebar {...props} />;

    } else if (process.env.NODE_ENV !== 'production' && sidebar.type === 'performance') {
        output = <PerformanceSidebar {...props} />;
    }

    return <Slide
        direction="right"
        in={Boolean(sidebar.type !== 'hidden')}
        onExited={onExited}
        onEntered={onEntered}
        mountOnEnter
        unmountOnExit
    >
        <div>{output}</div>
    </Slide>;
}
